const signature = [137,80,78,71,13,10,26,10];

const crc32 = (bytes: Uint8Array): number => {
  let crc = 0xffffffff;
  for (const byte of bytes) {
    crc ^= byte;
    for (let bit=0; bit<8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
  }
  return (crc ^ 0xffffffff) >>> 0;
};

export function validateAtlasPng(contents: ArrayBuffer, size: readonly [number,number], palette: readonly (readonly number[])[]): void {
  const bytes=new Uint8Array(contents),view=new DataView(contents);
  if(bytes.length<20||signature.some((value,index)=>bytes[index]!==value))throw new Error('invalid PNG signature');
  let offset=8,plte:Uint8Array|undefined,trns:Uint8Array|undefined,ihdr=false,idat=false,iend=false;
  while(offset<bytes.length){
    if(offset+12>bytes.length)throw new Error('truncated PNG chunk');
    const length=view.getUint32(offset),end=offset+12+length;if(end>bytes.length)throw new Error('truncated PNG chunk');
    const type=String.fromCharCode(...bytes.subarray(offset+4,offset+8)),data=bytes.subarray(offset+8,offset+8+length),stored=view.getUint32(offset+8+length);
    if(crc32(bytes.subarray(offset+4,offset+8+length))!==stored)throw new Error('PNG CRC mismatch');
    if(type==='IHDR'){if(ihdr||length!==13||view.getUint32(offset+8)!==size[0]||view.getUint32(offset+12)!==size[1]||data[8]!==8||data[9]!==3)throw new Error('invalid indexed PNG header');ihdr=true;}
    else if(type==='PLTE')plte=data;
    else if(type==='tRNS')trns=data;
    else if(['gAMA','cHRM','iCCP','sRGB'].includes(type))throw new Error(`forbidden PNG color chunk ${type}`);
    else if(type==='IDAT')idat=true;
    else if(type==='IEND'){if(length!==0||end!==bytes.length)throw new Error('invalid PNG end');iend=true;}
    offset=end;
  }
  if(!ihdr||!idat||!iend||plte?.length!==768)throw new Error('incomplete indexed PNG');
  for(let index=0;index<256;index++)for(let channel=0;channel<3;channel++)if(plte[index*3+channel]!==palette[index]?.[channel])throw new Error('PNG palette mismatch');
  if(!trns||!(trns.length===1&&trns[0]===0)&&!(trns.length===256&&trns[0]===0&&trns.slice(1).every(value=>value===255)))throw new Error('invalid PNG transparency');
}

export function decodeIndexedPngRows(inflated: Uint8Array, width: number, height: number): Uint8Array {
  if (!Number.isInteger(width)||!Number.isInteger(height)||width<=0||height<=0||inflated.length!==(width+1)*height) throw new Error('invalid indexed PNG scanline dimensions');
  const result=new Uint8Array(width*height);
  for(let y=0;y<height;y++){
    const filter=inflated[y*(width+1)]!;if(filter>4)throw new Error(`unsupported PNG filter ${filter}`);
    for(let x=0;x<width;x++){
      const encoded=inflated[y*(width+1)+1+x]!,left=x?result[y*width+x-1]!:0,up=y?result[(y-1)*width+x]!:0,upperLeft=x&&y?result[(y-1)*width+x-1]!:0,p=left+up-upperLeft,pa=Math.abs(p-left),pb=Math.abs(p-up),pc=Math.abs(p-upperLeft),paeth=pa<=pb&&pa<=pc?left:pb<=pc?up:upperLeft,predictor=filter===0?0:filter===1?left:filter===2?up:filter===3?Math.floor((left+up)/2):paeth;
      result[y*width+x]=(encoded+predictor)&255;
    }
  }
  return result;
}

export function validateTerrainIndices(indices: Uint8Array): void {
  const counts=new Uint32Array(25);
  for(const index of indices){if(index>24||(index>=5&&index<=8))throw new Error(`invalid terrain index ${index}`);counts[index]=counts[index]!+1;}
  for(let index=0;index<=4;index++)if(!counts[index])throw new Error(index===4?'terrain road coverage missing':`terrain index ${index} coverage missing`);
  if(!counts.slice(9).some((count)=>count>0))throw new Error('terrain building coverage missing');
}
